
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autostyle-near-me/[...slug]",
      function () {
        return require("private-next-pages/autostyle-near-me/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autostyle-near-me/[...slug]"])
      });
    }
  